module.exports = new __parcel__URL__("production.a13364ef.svg").toString();